import FormControlLabel from '@material-ui/core/FormControlLabel';
import Checkbox from '@material-ui/core/Checkbox';
import { createStyles, makeStyles, Theme } from '@material-ui/core';

import React from 'react';

import { baseTheme } from '../../../theme';

interface ICheckboxInputComponentProps {
  name: string;
  value: boolean;
  label: string;
  onChange: (event: any) => void;
  variant: 'dark' | 'light';
}

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      margin: '0 auto',
      cursor: 'default',
    },
    dark: {
      color: theme.palette.primary.main,
      '&$checked': {
        color: theme.palette.primary.main,
      },
    },
    light: {
      color: '#fff',
      '&$checked': {
        color: '#fff',
      },
    },
  }),
);

export default function CheckboxInputComponent(
  props: ICheckboxInputComponentProps,
) {
  const { name, value, label, onChange, variant = 'dark' } = props;
  const classes = useStyles(baseTheme);

  return (
    <FormControlLabel
      className={classes.root}
      control={
        <Checkbox
          className={variant === 'light' ? classes.light : classes.dark}
          checked={value}
          onChange={onChange}
          name={name}
        />
      }
      label={label}
    />
  );
}
